"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviousDate = void 0;
function getPreviousDate(date) {
    let previousDate = new Date(date);
    previousDate.setDate(previousDate.getDate() - 1);
    return previousDate;
}
exports.getPreviousDate = getPreviousDate;
